import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-center" };
const _hoisted_2 = { "aria-label": "..." };
const _hoisted_3 = { class: "pagination" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    class: "page-item disabled d-none d-md-block",
    "aria-current": "page",
    tabindex: "-1"
};
const _hoisted_6 = {
    class: "page-link",
    tabindex: "-1"
};
const _hoisted_7 = { class: "small text-muted" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", {
                    class: _normalizeClass(['page-item', _ctx.currentPage <= 1 ? 'disabled' : ''])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        tabindex: "-1",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.firstPage && _ctx.firstPage(...args)), ["prevent", "stop"]))
                    }, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-chevron-bar-left",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"
                                })
                            ], -1)
                        ]))])
                ], 2),
                _createElementVNode("li", {
                    class: _normalizeClass(['page-item', _ctx.currentPage <= 1 ? 'disabled' : ''])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.previusPage && _ctx.previusPage(...args)), ["prevent", "stop"]))
                    }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-chevron-left",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                })
                            ], -1)
                        ]))])
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(['page-item', _ctx.currentPage === page ? 'active' : '']),
                        "aria-current": "page",
                        tabindex: "-1"
                    }, [
                        _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _withModifiers(($event) => (_ctx.gotoPage(page)), ["prevent", "stop"])
                        }, _toDisplayString(page), 9, _hoisted_4)
                    ], 2));
                }), 256)),
                _createElementVNode("li", {
                    class: _normalizeClass(['page-item', _ctx.currentPage >= _ctx.totalPages ? 'disabled' : ''])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent", "stop"]))
                    }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-chevron-right",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                })
                            ], -1)
                        ]))])
                ], 2),
                _createElementVNode("li", {
                    class: _normalizeClass(['page-item', _ctx.currentPage >= _ctx.totalPages ? 'disabled' : ''])
                }, [
                    _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.lastPage && _ctx.lastPage(...args)), ["prevent", "stop"]))
                    }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-chevron-bar-right",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"
                                })
                            ], -1)
                        ]))])
                ], 2),
                _createElementVNode("li", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentPage) + " " + _toDisplayString(_ctx.$t('client.Common.Pager.Of')) + " " + _toDisplayString(_ctx.totalPages) + " | " + _toDisplayString(_ctx.$t('client.Common.Pager.Records')) + ": " + _toDisplayString(_ctx.records), 1)
                    ])
                ])
            ])
        ])
    ]));
}
